module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/theme-pic02@2x-81b87697c0023949a1b0e74c8fde568f.png";